import type { MouseEvent } from 'react';

import { ANALYTICS_EVENTS } from 'src/app/analytics/analyticsEvents';
import SideMenu, { SideMenuComponents } from 'src/app/components/Elements/SideMenu';
import * as paths from 'src/app/router/paths';
import { redirectToOnboarding, segmentAnalyticsEvent } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';
import { IS_MOBILE } from 'src/consts';

interface LoggedOutSideMenuProps {
  handleCloseMenu: () => void;
  showMenu?: boolean;
  hasGetStartedLink?: boolean;
  hasSignInLink?: boolean;
}

export const LoggedOutSideMenu = ({
  handleCloseMenu,
  hasGetStartedLink = true,
  hasSignInLink = true,
  showMenu = false,
}: LoggedOutSideMenuProps) => {
  const dispatch = useDispatch();

  const handleGetStartedClick = () => {
    const attributes = { isMobile: IS_MOBILE ? 'yes' : 'no' };
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.sideMenuSwitchNowClicked, { attributes }));
    dispatch(redirectToOnboarding('Navigation Bar'));
  };

  const getRedirectClickHandler = (handler: () => void) => (e: MouseEvent) => {
    e.preventDefault();
    handler();
    handleCloseMenu();
  };

  const { MenuButton, MenuLink } = SideMenuComponents;

  return (
    <SideMenu
      isShown={showMenu}
      onClose={handleCloseMenu}
      logoTo={paths.home.toPath()}
      onLogoClick={getRedirectClickHandler(paths.redirectHome)}
      isLogoPaddedOnLeftSide={true}
    >
      {hasGetStartedLink && (
        <MenuButton onClick={handleGetStartedClick} size="medium">
          Get started
        </MenuButton>
      )}

      <MenuLink to={paths.howItWorks.toPath()} onClick={handleCloseMenu}>
        How it works
      </MenuLink>

      <MenuLink to={paths.about.toPath()} onClick={handleCloseMenu}>
        About us
      </MenuLink>

      <MenuLink to={paths.doctors.toPath()} onClick={handleCloseMenu}>
        For doctors
      </MenuLink>

      <MenuLink to={paths.questions.toPath()} onClick={getRedirectClickHandler(paths.redirectQuestions)}>
        Questions
      </MenuLink>

      {hasSignInLink && (
        <MenuLink to={paths.login.toPath()} onClick={handleCloseMenu}>
          Sign in
        </MenuLink>
      )}
    </SideMenu>
  );
};
